export default function getPageTitle(title) {
  return title;
}
